import { Directive, ElementRef, Renderer2, Input } from '@angular/core';
import { AppState } from '../../config/state';

/**
 * Generated class for the CoDigitalIconDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[co-digital-icon]' // Attribute selector
})
export class CoDigitalIconDirective {
  element: any;
  @Input('source') source: any;
  constructor(private el: ElementRef, private state: AppState, private Render: Renderer2) {
  }

  ngOnInit(): void {
    if (this.source){
      this.getSourceImage().then(img => {
        this.el.nativeElement.innerHTML = img;
      });
    }
  }

  async getSourceImage(){
    switch(this.source){
      case 'hoopla':
        return `<img src="assets/imgs/128-hoopla.png" class="digital-icon-search" >`;
      case 'overdrive':
        return `<img src="assets/imgs/overdrive.jpg" class="digital-icon-search" >`;
      default:
        return '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/co-digital-icon/co-digital-icon.ts